import { createFileRoute, redirect } from "@tanstack/react-router";
import { homePathFor } from "@/config/roles";
import { session } from "@/lib/auth";

/** "/" is never a page: it forwards to the caller's portal or to login. */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    const { user } = session.get();
    if (session.isAuthenticated() && user) throw redirect({ to: homePathFor(user.role) });
    throw redirect({ to: "/login" });
  },
});
